module.exports = __webpack_public_path__ + "yichengdan.png?6bbedaf1e8c4cf3dbed2ff3e52d18d18";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yichengdan.png
// module id = 77
// module chunks = 0